import { useMemo } from 'react';
import { ListingTileFilterTarget } from 'src/contexts/MobileSortAndFilterContext';
import { ListingWithComp } from 'src/tiles/ListingTilesV2';

export const useQuantityListingCounts = (inventory: ListingWithComp[]) => {
  return useMemo(() => {
    return inventory.reduce(
      (acc, listing) => {
        if (!acc.targetCount[ListingTileFilterTarget.All]) {
          acc.targetCount[ListingTileFilterTarget.All] = 0;
        }
        if (!acc.targetCount[ListingTileFilterTarget.MyInventory]) {
          acc.targetCount[ListingTileFilterTarget.MyInventory] = 0;
        }
        if (!acc.targetCount[ListingTileFilterTarget.CompInventory]) {
          acc.targetCount[ListingTileFilterTarget.CompInventory] = 0;
        }

        acc.targetCount[ListingTileFilterTarget.All] += 1;
        if (listing.isCompListing) {
          acc.targetCount[ListingTileFilterTarget.CompInventory] += 1;
        } else {
          acc.targetCount[ListingTileFilterTarget.MyInventory] += 1;

          const quantityStr =
            listing.availQty >= 10 ? '10+' : listing.availQty + '';

          if (!acc.quantityCount[quantityStr]) {
            acc.quantityCount[quantityStr] = 0;
          }
          acc.quantityCount[quantityStr] += 1;
        }

        return acc;
      },
      {
        targetCount: {} as Record<ListingTileFilterTarget, number>,
        quantityCount: {} as Record<string, number>,
      }
    );
  }, [inventory]);
};
